export const api = {
    patrolTask: {
        queryAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', //查询告警详情
        queryPatrolTaskList: '/bas/electronicPatrol/queryPatrolTaskList.json',
        queryPatrolTaskDetail: '/bas/electronicPatrol/queryPatrolTaskDetail.json ', //查询巡更记录详情
        exportPatrolTask: '/bas/electronicPatrol/exportPatrolTask.json', //导出巡更记录列表
        queryPatrolRecordList: '/bas/electronicPatrol/queryPatrolRecordList.json', //查询巡更记录列表
        querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroupApi.json', //查询隶属中队
        queryElectronicPatrolPlanNameList: '/bas/electronicPatrol/queryElectronicPatrolPlanNameList.json', //巡逻计划名称列表
    }
}